import _ from 'underscore';
import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { HelpLink } from '@bingads-webui-react/help-link';
import { Text, Button, mergeClasses } from '@fluentui/react-components';
import { CheckmarkCircleFilled } from '@fluentui/react-icons';
import { LinkedInIconWhite, LinkedInLogo } from '@bingads-webui-campaign-react/linkedin-shared-components';

import { COMPANY_PAGE_LINKING_ACTIONS } from '../reducer';
import { useLoadCompanyPages } from '../hooks';
import { useAuthenticationStageStyles } from '../styles/authentication-stage-styles';

const FEATURES = [{
  key: 'ads',
  text: _TL_('Create ads to reach your LinkedIn audience'),
}, {
  key: 'monitor',
  text: _TL_('Monitor campaigns with data visualization'),
}, {
  key: 'access',
  text: _TL_('Access performance metrics'),
}];

export const AuthenticationStage = (props) => {
  const {
    state, dispatch, onCancel, serverError, logger,
  } = props;

  const classes = useAuthenticationStageStyles();
  const i18n = useContext(I18nContext);

  const onLinkClicked = useCallback(() => {
    logger.trace('Start LinkedIn authentication');
    dispatch({ type: COMPANY_PAGE_LINKING_ACTIONS.START_AUTHENTICATION });
  }, [dispatch, logger]);

  useLoadCompanyPages(state, dispatch, logger);

  return (
    <div className={mergeClasses('authentication-stage', classes.container)}>
      <div className={classes.contentContainer}>
        <div className={classes.logo}>
          <LinkedInLogo />
        </div>
        <Text as="h1" className={classes.title}>
          {i18n.getString(_TL_('Connect to your company\'s LinkedIn page'))}
        </Text>
        <span className={classes.description}>
          <span>
            {i18n.getString(_TL_('You must have permission to be a paid media admin for your company’s page to create a campaign. '))}
          </span>
          <HelpLink query="help:app54861" className={classes.helpLink}>{i18n.getString(_TL_('Learn more'))}</HelpLink>
        </span>
        <div className={mergeClasses('feature-items', classes.itemsContainer)}>
          {FEATURES.map(feature => (
            <div key={feature.key} className={classes.item}>
              <CheckmarkCircleFilled className={classes.checkmark} />
              <Text className={classes.itemText}>{i18n.getString(feature.text)}</Text>
            </div>
          ))}
        </div>
      </div>
      {serverError}
      <div className={classes.actionsContainer}>
        <Button className="step-cancel-button" onClick={onCancel}>
          {i18n.getString(_TL_('Cancel'))}
        </Button>
        <Button
          appearance="primary"
          className="connect-button"
          onClick={onLinkClicked}
          icon={<LinkedInIconWhite />}
        >
          {i18n.getString(_TL_('Connect'))}
        </Button>
      </div>
    </div>
  );
};

AuthenticationStage.propTypes = {
  state: PropTypes.shape({}).isRequired,
  dispatch: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  serverError: PropTypes.node,
  logger: PropTypes.shape({
    trace: PropTypes.func,
    error: PropTypes.func,
  }),
};

AuthenticationStage.defaultProps = {
  serverError: null,
  logger: {
    trace: _.noop,
    error: _.noop,
  },
};
